import { useQrLoginScanner } from "@app/auth/hooks";
import { trans } from "@mongez/localization";
import { FaCamera, FaQrcode } from "react-icons/fa";

/**
 * Scan a numeric student QR or an assigned reusable card and log in directly.
 */
export function QrLoginForm() {
  const scanner = useQrLoginScanner();

  return (
    <div className="space-y-5">
      <div className="space-y-1.5 text-center">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10 text-primary">
          <FaQrcode size={27} />
        </div>
        <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
          {trans("auth.qrLoginTitle")}
        </h2>
        <p className="text-sm text-muted-foreground dark:text-gray-300">
          {trans("auth.qrLoginDescription")}
        </p>
      </div>

      <div className="relative overflow-hidden rounded-2xl border border-gray-200 bg-gray-950 shadow-inner dark:border-gray-700">
        <video
          ref={scanner.videoRef}
          className="aspect-square w-full object-cover"
          muted
          playsInline
        />
        <div className="pointer-events-none absolute inset-8 rounded-2xl border-2 border-white/80 shadow-[0_0_0_999px_rgba(0,0,0,0.28)]" />
        <div className="pointer-events-none absolute inset-x-0 bottom-4 flex justify-center">
          <span className="rounded-full bg-black/65 px-3 py-1.5 text-xs font-medium text-white backdrop-blur">
            {scanner.processing
              ? trans("auth.qrLoggingIn")
              : trans("auth.qrPlaceCard")}
          </span>
        </div>
      </div>

      {scanner.cameraError ? (
        <div className="rounded-xl border border-red-200 bg-red-50 p-3 text-center text-sm text-red-700 dark:border-red-900 dark:bg-red-950/40 dark:text-red-300">
          {scanner.cameraError}
        </div>
      ) : (
        <div className="flex items-center justify-center gap-2 text-xs text-muted-foreground">
          <FaCamera />
          {trans("auth.qrCameraPrivacy")}
        </div>
      )}
    </div>
  );
}
